import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'tab-item',
    templateUrl: './tab-item.component.html',
    styles: [`
        .directory-tab-container { height: 100%; }
        .directory-tab-container .panel-body { height: 100%; margin-top: 0;}
        :host ::ng-deep .table-responsive {height: auto; position: absolute; left: 0; right: 0; top: 0; bottom: 0;}
    `]
})
export class TabItemComponent {
    @Input() title: string;
    @HostBinding('class.isActiveTab') @Input() active = false;
    @Input() tabId: string;
    @Input() numberLabel: string;
}



// WEBPACK FOOTER //
// /app/src/app/components/tabs/tab-item/tab-item.component.ts